import { pxToRem } from '../../../../utils';
export default (function (siteVars) {
  var minHeight = pxToRem(28);
  return {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: pxToRem(3),
    backgroundColor: siteVars.colors.grey[50],
    // $app-white
    borderColor: siteVars.colors.grey[250],
    color: siteVars.colors.grey[500],
    fontWeight: siteVars.fontWeightRegular,
    minHeight: minHeight,
    padding: "0 ".concat(pxToRem(16)),
    actionsMargin: pxToRem(5),
    dismissActionSize: minHeight,
    dismissActionColor: undefined,
    dismissiblePadding: "0 0 0 ".concat(pxToRem(16)),
    dangerColor: siteVars.colors.red[400],
    dangerBackgroundColor: siteVars.colors.red[50],
    dangerBorderColor: siteVars.colors.red[100],
    oof: false,
    oofColor: siteVars.colors.pink[600],
    oofBackgroundColor: siteVars.colors.pink[50],
    oofBorderColor: siteVars.colors.pink[100],
    infoColor: siteVars.colors.grey[500],
    infoBackgroundColor: siteVars.colors.grey[150],
    infoBorderColor: siteVars.colors.grey[200],
    urgent: false,
    urgentColor: siteVars.colors.white,
    urgentBackgroundColor: siteVars.colors.red[400],
    urgentBorderColor: siteVars.colors.red[400],
    headerFontWeight: siteVars.fontWeightBold,
    headerMargin: "0 ".concat(pxToRem(10), " 0 0"),
    iconMargin: "0 ".concat(pxToRem(10), " 0 0")
  };
});